module.exports = __webpack_public_path__ + "img/ftp.100dc035.png";